export default __webpack_public_path__ + "static/media/O1.b54f72aa.jpg";